import { formatDecimalPlaces } from '../../../helpers/functions/format-decimal-places'
import type { UserHostTaskSpecialWeekend } from '../../../services/users-tasks/users-hosts-tasks-specials-weekends/types'

interface Props {
  tasks: UserHostTaskSpecialWeekend[]
}

export const TaskLevelCard = ({ tasks }: Props) => {
  const task = tasks?.[0]
  const task2 = tasks?.[1]
  const task3 = tasks?.[2]

  const workdayProgress = task?.dayCompleted ?? 0

  const durationProgress = task2?.hourCompleted

  const incomeProgress = task3?.pointCompleted ?? 0

  return (
    <div className="w-full flex flex-row gap-2">
      <div className="flex items-start p-1">
        <div className="border border-gray-400 rounded-full px-3 py-1 text-xs font-semibold text-gray-700 bg-white">
          Lv.{task.levelTask}
        </div>
      </div>

      {/* Card */}
      <div className="flex-1 bg-white/70 backdrop-blur-sm rounded-xl p-4 shadow-sm">
        {/* Dia útil válido */}
        <div className="mb-4">
          <div className="flex items-center gap-1">
            <span className="font-semibold text-gray-700 text-sm">
              Dia útil válido
            </span>
          </div>

          <div className="w-full bg-gray-200 rounded-full h-3 mt-1">
            <div
              className="h-3 rounded-full bg-pink-400"
              style={{ width: `${(workdayProgress / task.minDay) * 100}%` }}
            />
          </div>

          <span className="text-xs text-gray-500 mt-1 block">
            {Math.round(workdayProgress)}/{task?.minDay}
          </span>
        </div>

        {/* Duração válida */}
        <div className="mb-4">
          <div className="flex items-center justify-between">
            <span className="font-semibold text-gray-700 text-sm">
              Duração válida
            </span>

            <button className="text-xs text-blue-500 font-semibold">
              Detalhes &gt;
            </button>
          </div>

          <div className="w-full bg-gray-200 rounded-full h-3 mt-1">
            <div
              className="h-3 rounded-full bg-pink-400 overflow-hidden"
              style={{ width: `${(durationProgress / task2?.minHour) * 100}%` }}
            />
          </div>

          <span className="text-xs text-gray-500 mt-1 block">
            {Math.round(durationProgress)}/{task2?.minHour}
          </span>
        </div>

        {/* Renda válida */}
        <div>
          <div className="flex items-center gap-1">
            <span className="font-semibold text-gray-700 text-sm">
              Renda válida
            </span>
          </div>

          <div className="w-full bg-gray-200 rounded-full h-3 mt-1">
            <div
              className="h-3 rounded-full bg-pink-400"
              style={{
                width: `${(incomeProgress / task3?.minPoint) * 100}%`,
                maxWidth: '100%',
              }}
            />
          </div>

          <span className="text-xs text-gray-600 mt-1 block font-semibold">
            💎 {incomeProgress}/{formatDecimalPlaces(task3?.minPoint ?? 0)}
          </span>
        </div>
      </div>
    </div>
  )
}
